import React, { useState } from 'react'
import './Nationality.css'

const NATIONALITY_API = "https://api.nationalize.io"


const Nationality = () => {
    const [name, setName] = useState("")
    const [data, setData] = useState("")
    const [show, setShow] = useState(false)
    const [userName, setUserName] = useState("")

    const fetchData=()=>{
        fetch(`${NATIONALITY_API}?name=${name}`)
            .then(response => response.json())
            .then(json =>
                setData(json));
        setUserName(name)
        setShow(true)
        setName("")
    }

    const alert_name=()=>{
        return( 
            alert("Please enter your name to continue")
            )
        
    }

    const showData = (e) => {
        e.preventDefault()
        {name? fetchData() : alert_name() }  
    }

    const inputChange = (e) => {
        setName(e.target.value)
        setShow(false)
    }
    console.log(data)

    return (
        <div className="nationality">
            <form onSubmit={showData} >
                <span>Name</span><input type="text" value={name} onChange={inputChange} /><br />
                <button type="submit">Show my Info</button>
            </form>
            <div className="results">
                {show ?
                    <div className="results_record">
                        <h2 className="results_heading">Hello {userName.toUpperCase()}, There are {data ? data.country.length : ""} country in my record where most  people with the name "{userName.toUpperCase()}" exists. Have a look at these different Countries:- </h2>

                        {data && data.country.map((country, i) =>
                        (
                            <div className="results_countries" key={i}>
                                <h2> {i + 1}. Country : {country.country_id} :-  </h2>
                                <h2> The probabillity that you live in {country.country_id} is {Math.floor((country.probability) * 100)}%</h2>
                            </div>
                        )
                        )}
                        <h3>Hope i was able to guess it correctly.Thanks for your time.</h3>

                    </div> : <h2>The result will be displayed here </h2>

                }
            </div>

        </div>
    )
}

export default Nationality
